import { Progress } from "reactstrap"

type progressBar ={
     pageNumber:number,
     totalpage:number,
     mystyle:any
     now?:number
    
}
const ProgressBar =({pageNumber,totalpage,mystyle,now}:progressBar)=>{
    
       
    return(
       <div
       className="d-flex justify-content-around"
        style={mystyle}>
          <Progress 
           
           className= { `my-auto progress-bar1 ${totalpage == 0 && pageNumber ==0 ? 'w-100':''}` }
           animated
           color ='success'
           
           value={
            totalpage === 0 
              ? now 
              : Math.min(Number((pageNumber / totalpage) * 100), 100)
          }>
                {totalpage === 0
    ? `${Math.round(now?now:123)}%`
    : `${Math.round((pageNumber / totalpage) * 100)}%`}
          </Progress>
       </div>
    )
}

export default ProgressBar;